export default __webpack_public_path__ + "static/logo4-light-91ed716d35bd2313be214147058a2f9c.svg";